module.exports = __webpack_public_path__ + "img/share_friend.d03eeb94.svg";